import React from 'react'
import Herosection from './Herosection.jsx'
import Navber from '../../../Components/Navber.jsx'
import AboutSection from './AboutSection.jsx'
import FeaturedDestinations from './FeaturedDestinations.jsx'
import WhyJayraj from './WhyJayraj.jsx'
import Testimonials from './Testimonials.jsx'
import HoneymoonVideoSection from './HoneymoonVideoSection.jsx'
import PopularWeddingPackages from './PopularWeddingPackages.jsx'

function MainLayout() {
  return (
    <div>
      <Navber />
      <Herosection />
      <FeaturedDestinations />
      <PopularWeddingPackages />
      <AboutSection />
      <HoneymoonVideoSection />
      <WhyJayraj />
      <Testimonials/>
       
    </div>
  )
}

export default MainLayout